import { DEVICE_STATUS } from '@/pages/Administration/Devices/Devices.constants';

import { DEVICE_STATUS_ICON_LIST } from './DeviceStatusIcon.constant';
import type { DeviceStatusIconProps } from './DeviceStatusIcon.types';

const DeviceStatusIcon = (props: DeviceStatusIconProps) => {
  const { deviceType, status } = props;

  const getIconStatusColor = (deviceStatus: string) => {
    switch (deviceStatus) {
      case DEVICE_STATUS.DEVICE_ACTIVATED:
        return 'New';
      case DEVICE_STATUS.CONFIG_SUCCESS:
        return 'Active';
      case DEVICE_STATUS.CONFIG_FAILED:
        return 'Error';
      case DEVICE_STATUS.JOB_FAILED:
        return 'Error';
      case DEVICE_STATUS.OPERATIONAL:
        return 'Active';
      case DEVICE_STATUS.DEPLOYMENT_FAILED:
        return 'Error';
      case DEVICE_STATUS.ERROR:
        return 'Error';
      case DEVICE_STATUS.UNKNOWN:
        return 'Unknown';
      case DEVICE_STATUS.DISABLED:
        return 'Disabled';
      case DEVICE_STATUS.NEW:
        return 'New';
      case DEVICE_STATUS.DECOMMISSIONING:
        return 'Warning';
      case DEVICE_STATUS.CATEGORY_FAILED:
        return 'Warning';
      case DEVICE_STATUS.PENDING_RESTART:
        return 'Warning';
      case DEVICE_STATUS.WARNING:
        return 'Warning';
      default:
        return 'Unknown';
    }
  };
  const selectedDeviceIcon = DEVICE_STATUS_ICON_LIST.find(
    (item) =>
      item.devicetype === deviceType &&
      item.status === getIconStatusColor(status)
  );

  const SelectedIcon = selectedDeviceIcon?.icon;

  return <>{SelectedIcon ? <SelectedIcon /> : null}</>;
};
export default DeviceStatusIcon;
